import React from "react"
import { connect } from "react-redux"
import { campaignPopupSortPerformanceList, updateCampaignPopupTablePage } from "../../campaignPopupActions"
import Table from "../../../common/components/table/table"
import CampaignsTableConsts from "../../../campaignsV2/campaignsTableConsts"
import Pagination from "../../../common/components/pagination"
import { getColumnsForTab } from "../../CampaignPopupColumns"

class CampaignPopupPerformanceByDeviceList extends React.Component {
  constructor(props) {
    super(props)

    this.tableName = "performanceByDevice"
    this.columns = getColumnsForTab(this.props.campaign.provider_id, this.props.campaign.post_style, "device")
  }

  sortDevicesBy = (column) => {
    this.props.dispatch(campaignPopupSortPerformanceList(column, "performanceByDevice"))
  }

  getHeader = () => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      value: column.title,
      clickable: true,
      cellSize: column.cellSize,
    }))

    return {
      cells,
    }
  }

  getRow = (device) => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      cssClasses: column.cssClasses || [],
      value: column.defaultFormat(device[column.fieldName]),
      cellSize: column.cellSize,
    }))

    return { cells }
  }

  getSummaryRow = (summaryData) => {
    const cells = Object.values(this.columns).map((column) => ({
      fieldName: column.fieldName,
      value:
        column.fieldName === CampaignsTableConsts.device.fieldName
          ? "Total"
          : column.defaultFormat(summaryData[column.fieldName]),
    }))

    return { cssClasses: ["summary-row"], allowRowSelection: false, cells }
  }

  render() {
    const header = this.getHeader()
    let rows = []
    const { performanceByDevice, summaryRow, currentPage, itemsPerPage } = this.props

    // Add summary row if data is available
    if (performanceByDevice.length > 0) {
      rows.push(this.getSummaryRow(summaryRow))
    }

    // Add data rows with pagination
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = Math.min(currentPage * itemsPerPage, performanceByDevice.length)

    for (let i = startIndex; i < endIndex; i++) {
      rows.push(this.getRow(performanceByDevice[i]))
    }

    // Add pagination if necessary
    const pagination =
      performanceByDevice.length > itemsPerPage ? (
        <Pagination
          itemsArr={performanceByDevice.length}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          updatePage={(updatedPage) => {
            this.props.dispatch(updateCampaignPopupTablePage(updatedPage, this.tableName))
          }}
        />
      ) : null

    return (
      <div>
        <Table
          header={header}
          rows={rows}
          sort={{
            sortBy: this.props.sortBy,
            sortDirection: this.props.sortDirection,
            sortHandler: this.sortDevicesBy,
          }}
          scrolling={{
            containerClass: ".campaign-popup-container",
            includeNavigationBar: false,
          }}
          cssClasses={["campaign-popup-list"]}
          isLoadingData={performanceByDevice.length === 0}
        />
        {pagination}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    sortBy: state.campaignPopupV2.performanceByDevice.sortBy,
    sortDirection: state.campaignPopupV2.performanceByDevice.sortDirection,
    performanceByDevice: state.campaignPopupV2.performanceByDevice.dataForTable,
    summaryRow: state.campaignPopupV2.performanceByDevice.summaryRow,
    itemsPerPage: state.campaignPopupV2.performanceByDevice.itemsPerPage,
    currentPage: state.campaignPopupV2.performanceByDevice.currentPage,
    campaign: state.campaignPopupV2.campaign,
  }
}

export default connect(mapStateToProps)(CampaignPopupPerformanceByDeviceList)
